var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageBackground = function SvgImageBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 199 89"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 89,
    fill: "#e6eaeb",
    rx: 0,
    ry: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65 15h70v60H65z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6eaeb",
    d: "M139.5 24c0-7.425-6.075-13.5-13.5-13.5H72c-7.425 0-13.5 6.075-13.5 13.5v40.5C58.5 71.925 64.575 78 72 78h54c7.425 0 13.5-6.075 13.5-13.5zm-60.75 0c3.713 0 6.75 3.037 6.75 6.75s-3.037 6.75-6.75 6.75S72 34.463 72 30.75 75.037 24 78.75 24m54 40.5c0 3.713-3.038 6.75-6.75 6.75H73.35c-3.037 0-4.387-3.713-2.362-5.738l12.15-12.15c1.35-1.35 3.374-1.35 4.725 0l2.024 2.025c1.35 1.35 3.375 1.35 4.726 0l22.274-22.274c1.35-1.35 3.375-1.35 4.726 0l10.125 10.125c.675.674 1.012 1.35 1.012 2.362z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6C8A8E"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 2,
    x: 51.5,
    y: 36.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 2,
    x: 51.5,
    y: 43.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 2,
    x: 79.5,
    y: 50.5,
    rx: 1
  }))));
};
export { SvgImageBackground as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTk5IDg5IiBmaWxsPSJub25lIgogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHJlY3Qgcng9IjAiIHJ5PSIwIiB3aWR0aD0iMTk5IiBoZWlnaHQ9Ijg5IiBmaWxsPSIjZTZlYWViIiAvPgogIDxyZWN0IHg9IjY1IiB5PSIxNSIgd2lkdGg9IjcwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjZmZmIiAvPgogIDxnIHRyYW5zZm9ybT0nc2NhbGUoMS41KSwgdHJhbnNsYXRlKDkgLTEzKSc+CiAgICA8cGF0aCBkPSJNODQgMjlDODQgMjQuMDUgNzkuOTUgMjAgNzUgMjBIMzlDMzQuMDUgMjAgMzAgMjQuMDUgMzAgMjlWNTZDMzAgNjAuOTUgMzQuMDUgNjUgMzkgNjVINzVDNzkuOTUgNjUgODQgNjAuOTUgODQgNTZWMjlaTTQzLjUgMjlDNDUuOTc1IDI5IDQ4IDMxLjAyNSA0OCAzMy41QzQ4IDM1Ljk3NSA0NS45NzUgMzggNDMuNSAzOEM0MS4wMjUgMzggMzkgMzUuOTc1IDM5IDMzLjVDMzkgMzEuMDI1IDQxLjAyNSAyOSA0My41IDI5Wk03OS41IDU2Qzc5LjUgNTguNDc1IDc3LjQ3NSA2MC41IDc1IDYwLjVIMzkuOUMzNy44NzUgNjAuNSAzNi45NzUgNTguMDI1IDM4LjMyNSA1Ni42NzVMNDYuNDI1IDQ4LjU3NUM0Ny4zMjUgNDcuNjc1IDQ4LjY3NSA0Ny42NzUgNDkuNTc1IDQ4LjU3NUw1MC45MjUgNDkuOTI1QzUxLjgyNSA1MC44MjUgNTMuMTc1IDUwLjgyNSA1NC4wNzUgNDkuOTI1TDY4LjkyNSAzNS4wNzVDNjkuODI1IDM0LjE3NSA3MS4xNzUgMzQuMTc1IDcyLjA3NSAzNS4wNzVMNzguODI1IDQxLjgyNUM3OS4yNzUgNDIuMjc1IDc5LjUgNDIuNzI1IDc5LjUgNDMuNFY1NloiIGZpbGw9IiNlNmVhZWIiLz4KICA8L2c+CiAgPGcgaWQ9InN2Z182Ij4KICAgIDxyZWN0IGlkPSJzdmdfOSIgZmlsbD0iIzZDOEE4RSIgcng9IjEiIGhlaWdodD0iMiIgd2lkdGg9Ijk2IiB5PSIzNi41IiB4PSI1MS41Ii8+CiAgICA8cmVjdCBpZD0ic3ZnXzEwIiBmaWxsPSIjNkM4QThFIiByeD0iMSIgaGVpZ2h0PSIyIiB3aWR0aD0iOTYiIHk9IjQzLjUiIHg9IjUxLjUiLz4KICAgIDxyZWN0IGlkPSJzdmdfMTEiIGZpbGw9IiM2QzhBOEUiIHJ4PSIxIiBoZWlnaHQ9IjIiIHdpZHRoPSI0MCIgeT0iNTAuNSIgeD0iNzkuNSIvPgogIDwvZz4KPC9zdmc+";